export default __webpack_public_path__ + "static/media/profile-pic.50d72c0f.png";